
import './index.less';

import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { formatDate } from "@/javascript/formatDate"
import Swiper from 'swiper'

import Cpts022 from '@/components/public-components/cpts022/index.vue'
import Cpts024 from '@/components/public-components/cpts024/index.vue'
import collect from '@/components/public-components/collect/index.vue'

import scienceCom from '@/components/public-components/scienceComment/index'
import util from '@/javascript/util'
import bus from '@/javascript/bus'
import mapUtil from '@/javascript/mapUtil'
import EsQuery from '@/javascript/esQuery'

import videoBox from '@/components/public-components/videoStart/index'

import mapList from '@/components/public-components/mapList/index.vue'
import Footer from "@/components/lyx-components/lyx-footer/index"
import goBack from '@/components/public-components/goBack/index.vue'

export default {
directives: {
TransferDom
},
components: {
Confirm,
Cpts022,
Cpts024,
collect,
scienceCom,
videoBox,
mapList,
Footer,
goBack
},
data () {
return {
isLogin: Boolean(bus.userInfo.access_token),
business: {},
gallery: [],
aroundList: [],
commentList: [],
businessEntity: {},
agritainmentRule: {
119001: '停车场',
119002: '包厢',
119003: '观景台',
119004: '无线网络',
119005: '采摘园',
119006: '空调',
119007: '电视',
119008: '暖气',
119009: '免费接送',
119010: '拖鞋',
119011: '全天热水',
119012: '热水壶',
119013: '自动麻将',
119014: 'KTV'
},
driveCampRule: { 0: '免费WIFI', 1: '停车场', 2: '充电车位', 3: '木屋', 4: '房产', 5: '集装箱', 6: '帐篷' },
tourVillageRule: { 0: '滑雪', 1: '停车场', 2: '垂钓', 3: '餐厅', 4: '露营', 5: 'KTV' },
minHeight: 0,
briefAll: false,
recommendList: [],
passWord: {
identiferId: '',
articleSite: '',
moduleCode: this.$route.params.code,
collTypes: this.$route.params.code,
name: '',
picUrl: '',
appCode: 62
},
infiniteAll: true,
isShowInfiniteAll: true,
jj_text: '',
weatherData: '',
videoShow: false,
videoUrl: '',
videoUrl2: '',
notesList: [],
njlActive: 0,
labelList: ['亲子', '野营', '采摘', '种植', '团建'],
agritainmentList: [],
location: {},
indexNameType: '',
serviceFacility: {},
wxLink: false,
showMapList: false
}
},
created () {
const _this = this
let ua = navigator.userAgent.toLowerCase();
if (ua.match(/MicroMessenger/i) == "micromessenger") {

wx.miniProgram.getEnv((res) => {
if (res.miniprogram) {
_this.wxLink = true
} else {

}
})
} else {
_this.wxLink = false

}
},
mounted () {
this.minHeight = document.documentElement.clientHeight - this.$refs.footer.$el.offsetHeight;

this.init()

mapUtil.locate((data) => {
this.location = data
}, (data) => {
this.location = data
})
},
watch: {
"$route": {
handler (val) {
this.init()
}
}
},
computed: {
videoShow2 () {
return this.videoShow
}
},
methods: {
seeMore () {
this.infiniteAll = !this.infiniteAll
if (!this.infiniteAll) {
this.jj_text = this.businessEntity.summary
} else {
this.jj_text = this.businessEntity.summary

}
},
videoClick (url) {
this.videoShow = true
this.videoUrl = url + '?' + Math.random()
},
init () {
this.passWord.articleSite = window.location.pathname + window.location.hash
let getDataUrl = ''

this.$http.get('/api/wtcp-bics/public/periphery/' + this.$route.params.id).then((response) => {

const businessData = response.data.data
let businessEntity = {},
catalog = this.XQSC_TYPE_CODE.CY,
serviceType = this.SERVICE_TYPE.CY
businessEntity = businessData
this.passWord.identiferId = businessData.id

if (businessEntity.openTime && businessEntity.openTime.indexOf(',') != -1) {
const openTime = businessEntity.openTime.split(',')
businessEntity.openTime = openTime[2] + '~' + openTime[3]
}

if (businessData.fileList.image) {
let gallery = []
if (businessData.fileList.image) {
gallery = businessData.fileList.image.all.materials
gallery.forEach(item => {
if (item.fileUrl.indexOf('\\') != -1) {
item.fileUrl = item.fileUrl.replaceAll("\\", "/\/")
}
item.src = this.PIC_BASE_URL + item.fileUrl
})
}
this.$set(this, 'gallery', gallery)
this.passWord.picUrl = businessData.fileList.image.all.materials[0].fileUrl

}

if (businessData.fileList.video && businessData.fileList.video.default) {
this.$set(this, 'videoUrl2', businessData.fileList.video.default[0].fileUrl)
}

if (this.$route.params.code == this.XXCJ_TYPE_CODE.LXS) {
this.jj_text = businessData.travelAgentEntity.summary

} else if (this.$route.params.code == this.XXCJ_TYPE_CODE.CY) {
this.jj_text = businessData.summary

}
businessEntity.label = businessEntity.phone ? businessEntity.phone.split(',') : []
businessEntity.areaName = businessEntity.regionFullName ? '南郑·' + businessEntity.regionFullName.split(',')[1] : ''

this.$set(this, 'businessEntity', businessEntity)

if (this.businessEntity.summary.length >= 63) {
this.jj_text = this.businessEntity.summary

this.isShowInfiniteAll = true
} else {
this.jj_text = this.businessEntity.summary
this.isShowInfiniteAll = false
}

this.passWord.name = businessEntity.title
this.passWord.collTypes = catalog
const business = {}
business.titleImageUrl = businessData.fileList.image.titleImage ? businessData.fileList.image.all.materials[0].fileUrl : ''
business.serviceType = serviceType
business.summary = businessEntity.summary
business.title = businessEntity.title

this.$set(this, 'business', business)
const bg = this.gallery.length > 0 ? this.gallery[0].src : (window.location.origin + '/static/zg-img/banner_img.png')
if (util.isWeiXin()) {
const shareData = typeof (shareData) === 'undefined' ? {
title: businessEntity.title,
desc: businessEntity.summary || '',
imgUrl: bg,
link: window.location.href
} : shareData;

this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href) + '&appId=' + this.WX_APPID).then((response) => {
util.initWxConfig(response.data.data, shareData)
})
}


if (bus.userInfo.user) {
const userInfo = bus.userInfo.user,
history = {
catalog: catalog,
serviceType: serviceType,
title: businessEntity.subTitle ? businessEntity.subTitle : businessEntity.title,
url: this.$route.path,
userId: userInfo.id,
username: userInfo.username,
picUrl: this.$route.params.code == this.XXCJ_TYPE_CODE.LXS ? businessEntity.titleImage : businessData.fileList.image.titleImage.materials[0].fileUrl
}
bus.$set(bus, 'history', history)
} else {

}
}).then(() => {
if (this.$refs.businessService) {
this.$refs.businessService.init()
}

const _this = this
const querystring = require('querystring');
const scenicEsQuery = new EsQuery()

scenicEsQuery
.addStartWith("deptCode", _this.DEPT_CODE.DEPTCODE, scenicEsQuery.and, false)
.addGeoSort("geoPoint", scenicEsQuery.desc, _this.businessEntity.latitude, _this.businessEntity.longitude)
.addPage(0, 3)
const scenicEsJsonQuery = JSON.stringify(scenicEsQuery.getArray())
_this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: _this.INDEX_NAME_TYPE.scenic,
esJsonQuery: scenicEsJsonQuery
})).then(function (response) {
const aroundList = response.data.data
_this.$set(_this, 'aroundList', aroundList)
}).then(() => {
new Swiper('.around-swiper', {
slidesPerView: 'auto',
spaceBetween: 15,
freeMode: true,
observer: true,
observeParents: true
})
})


_this.$http.get('/api/wtcp-weather/public/weather/detail/1/' + _this.businessEntity.region.substring(0, 4)).then(res => {
_this.weatherData = res.data.data && res.data.data.today ? res.data.data.today : ''
}).then(() => {
_this.$http.get('/static/json/weather/weatherConditionData.json').then((response) => {
response.data.forEach(item => {
if (item.codeName == _this.weatherData.phenomenon) {
_this.$set(_this.weatherData, 'icon', item.weatherIconUrl)
}
})
})
})

















_this.njlabelListL(_this.labelList[0], 0)


const recommendEsQuery = new EsQuery()
recommendEsQuery.addStartWith("region", _this.businessEntity.region.substring(0, 4), recommendEsQuery.and, false)

if (_this.$route.params.code != _this.XXCJ_TYPE_CODE.NJL) {
recommendEsQuery.addStartWith("category", _this.$route.params.code, recommendEsQuery.and, false)
_this.indexNameType = _this.INDEX_NAME_TYPE.periphery
} else {
_this.indexNameType = _this.INDEX_NAME_TYPE.rural
recommendEsQuery.addPage(0, 4)
}
recommendEsQuery.addPage(0, 3)
const recommendEsJsonQuery = JSON.stringify(recommendEsQuery.getArray())
_this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: _this.indexNameType,
esJsonQuery: recommendEsJsonQuery
})).then(function (response) {
let list = response.data.data
let flag = -1
list.forEach((item, index) => {
if (item._id === _this.businessEntity.id) {
flag = index
}
})
if (flag > -1) {
list.splice(flag, 1)
}
_this.$set(_this, 'recommendList', list)
})

document.title = _this.businessEntity.title

})

/**
* 评价
*/







},
gpsJump: function () {
/**
* 定位
*/
const _this = this
if (!_this.wxLink) {
mapUtil.locate((data) => {
window.location.href = 'https://map.qq.com/nav/drive#routes/page?eword=' + this.businessEntity.title + '&noback=&referer=groupActivity_myapp&ch=mc_h5marker&start=' + data.position.lng + ',' + data.position.lat + '&dest=' + this.businessEntity.longitude + ',' + this.businessEntity.latitude + '&sword=我的位置'
}, (data) => {
window.location.href = 'https://map.qq.com/nav/drive#routes/page?eword=' + this.businessEntity.title + '&noback=&referer=groupActivity_myapp&ch=mc_h5marker&start=' + data.position.lng + ',' + data.position.lat + '&dest=' + this.businessEntity.longitude + ',' + this.businessEntity.latitude + '&sword=我的位置'
})
} else {
let key = 'LTPBZ-7DQC2-NA3UR-CL64I-WAADJ-3ABMR';  
let referer = '一部手机游涉县';   
let endPoint = JSON.stringify({  //终点
'name': _this.businessEntity.title,
'latitude': _this.businessEntity.latitude,
'longitude': _this.businessEntity.longitude
});
let navigation = 1;
wx.miniProgram.navigateTo({
url: 'plugin://routePlan/index?key=' + key + '&referer=' + referer + '&endPoint=' + endPoint + '&navigation=' + navigation
})
}
},
briefToggle () {
this.briefAll = this.briefAll ? false : true
},
njlabelListL (item, index) {
const _this = this
_this.njlActive = index
/**
* 当前城市农家乐
*/
let name = ''
if (item === '野营') {
name = '野外拓展'
} else if (item === '采摘') {
name = '生态采摘'
} else {
name = item
}
const agritainmentEsQuery = new EsQuery()
const querystring = require('querystring');
agritainmentEsQuery.addStartWith("region", _this.businessEntity.region, agritainmentEsQuery.and, false)
.addSort("weight", agritainmentEsQuery.desc, false)


const agritainmentEsJsonQuery = JSON.stringify(agritainmentEsQuery.getArray())
_this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: _this.INDEX_NAME_TYPE.rural,
esJsonQuery: agritainmentEsJsonQuery
})).then(function (response) {
_this.agritainmentList = []
const agritainmentList = response.data.data
if (!agritainmentList) {
return
}
agritainmentList.map(item => {


item._source.service = item._source.serviceFacility ? item._source.serviceFacility.split(',') : []
item._source.serviceNum = item._source.service.length
let serviceArr = item._source.service.map(item2 => {
return _this.agritainmentRule[item2]
})
item._source.service = serviceArr.splice(0, 5).join(' ')
})
_this.agritainmentList = agritainmentList
})
}
}
}
